let routes = [
  {
    path: '/inscription-au-registre-etudiants-candidats',
    component: () => import('../views/InscriptionAuRegistreEtudiantsCandidats.vue'),
    props: true
  },
  {
    path: '/inscription-au-registre-etudiants-candidats/:step',
    component: () => import('../views/InscriptionAuRegistreEtudiantsCandidats.vue'),
    props: true
  }
]

export default routes;